export default __webpack_public_path__ + "static/media/include_7_male@2x.4db3ae2e.jpg";